import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  // Button,
  ListGroup,
  ListGroupItem,
  Progress
} from "shards-react";

const UserDetails = ({ userDetails }) => {
  const localId = window.sessionStorage.getItem('userid');
  return (
    <Card small className="mb-4 pt-3" style={{ height: "100%" }}>
      <CardHeader className="border-bottom text-center" style={{ paddingBottom: "50px" }}>
        <div className="mb-3 mx-auto">
          <img
            className="rounded-circle"
            src={userDetails.avatar}
            alt={userDetails.name}
            width="110"
          />
        </div>
        <h4 className="mb-0">{localId}</h4>
        <span className="text-muted d-block mb-2">{userDetails.jobTitle}</span>
        {/* <Button pill outline size="sm" className="mb-2">
        <i className="material-icons mr-1">person_add</i> Follow
      </Button> */}
      </CardHeader>
      <ListGroup flush>
        <ListGroupItem className="px-4">
          <div className="progress-wrapper">
            <strong className="text-muted d-block mb-2">
              {userDetails.performanceReportTitle}
            </strong>
            <Progress
              className="progress-sm"
              value={userDetails.performanceReportValue}
            >
              <span className="progress-value">
                {userDetails.performanceReportValue}%
              </span>
            </Progress>
          </div>
        </ListGroupItem>
        <ListGroupItem className="p-4">
          <strong className="text-muted d-block mb-2">
            {userDetails.metaTitle}
          </strong>
          <span>{userDetails.metaValue}</span>
        </ListGroupItem>
      </ListGroup>
    </Card>
  )
};

UserDetails.propTypes = {
  /**
   * The user details object.
   */
  userDetails: PropTypes.object
};

UserDetails.defaultProps = {
  userDetails: {
    name: "Admin",
    avatar: require("../../images/avatars/user (1).png"),
    jobTitle: "페이지 관리자",
    performanceReportTitle: "관리권한",
    performanceReportValue: 100,
    metaTitle: "세부설명",
    metaValue:
      "관리자 권한입니다."
  }
};

export default React.memo(UserDetails);
